import { render, staticRenderFns } from "./event-accept.vue?vue&type=template&id=2cf6a7f4&scoped=true"
import script from "./event-accept.vue?vue&type=script&lang=js"
export * from "./event-accept.vue?vue&type=script&lang=js"
import style0 from "./event-accept.vue?vue&type=style&index=0&id=2cf6a7f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf6a7f4",
  null
  
)

export default component.exports